<!--
/**
* @name: Record.vue
* @description: 客户浏览记录列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <h4>销售渠道：</h4>
        <span>{{ channelName }}</span>
      </y-query-item>
      <y-query-item class="ml-3">
        <h4>open ID：</h4>
        <span>{{ openId }}</span>
      </y-query-item>
      <y-query-item class="ml-3">
        <h4>手机号码：</h4>
        <span>{{ phone }}</span>
      </y-query-item>
    </y-query>
    <k-table :data="recordList" @sort="onSort" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="recordList && recordList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import { NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_USER_VISIT_PAGELIST } from "@/assets/modules/apiList";
const initPara = () => ({
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      visitTimeSorter: true,
      recordList: [],
      channelName: "",
      openId: "",
      phone: "",
      para: initPara(),
      total: 0,
      id: "",
    };
  },
  methods: {
    initColumns() {
      const visitTimeSorter = this.visitTimeSorter;
      return [
        {
          name: "访问微店",
          field: "smallShopName",
          style: {
            width: 150,
            textAlign: "center",
          },
        },
        {
          name: "访问时间",
          field: "visitTime",
          sorter: visitTimeSorter,
          style: { textAlign: "center" },
        },
        {
          name: "分销员",
          field: "shopMemberName",
          style: { textAlign: "center" },
        },
      ];
    },
    onSort({ type, field, name }) {
      type == 1 ? (this.para.orders = { asc: false, column: "visitTime" }) : (this.para.orders = { asc: true, column: "visitTime" });
      this.getRecordList(this.id);
    },
    getRecordList(id) {
      let { para } = this;
      para.memberUserId = id;
      this.$fetch({
        api: NESTLE_MEMBER_BACK_SERVER_BACK_MEMBER_USER_VISIT_PAGELIST,
        para,
      }).then((res) => {
        this.recordList = res.pageList;
        this.total = res.total;
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getRecordList(this.id);
    },
  },
  created() {
    const { channelName, openId, phone, id } = this.$route.query;
    this.channelName = channelName != "null" ? channelName : "";
    this.openId = openId != null ? openId : "";
    this.phone = phone != null ? phone : "";
    this.id = id;
    this.getRecordList(id);
  },
  beforeRouteUpdate(to, from, next) {
    const { channelName, openId, phone, id } = to.query;
    this.channelName = channelName != "null" ? channelName : "";
    this.openId = openId != null ? openId : "";
    this.phone = phone != null ? phone : "";
    this.id = id;
    this.getRecordList(id);
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
